import { type PageTabsItem } from '../ui/page-tabs/types'

export const TASK_MANAGEMENT_TAB_ITEMS: PageTabsItem[] = [
  {
    label: 'Action Required',
    value: 'action-required',
    to: '/dashboard/task-management/action-required',
  },
  {
    label: 'Action Completed',
    value: 'action-completed',
    to: '/dashboard/task-management/action-completed',
  },
]

export const ACTION_ACCORDION_MENU_NAME_MAP = {
  rfe: 'RFE',
  interview: 'Interview',
  biometric: 'Biometric',
  caseInquiryEligible: 'Case Inquiry Eligible',
  aosEligible: 'AOS Eligible',
} as const
